"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var Speech_1 = __importDefault(require("./Speech"));
var throttler = function (callback, interval) {
    var event_target = null;
    return function (event) {
        if (!event_target) {
            event_target = event.target;
            setTimeout(function () {
                callback(event_target);
                event_target = null;
            }, interval);
        }
    };
};
var HighLightLine = function (props) {
    var _a = React.useState(1), line = _a[0], setLine = _a[1];
    var div_ref = React.useRef();
    React.useEffect(function () {
        // console.log(`trying to scroll to top: ${div_ref.current}`);
        div_ref.current.scroll(0, 0);
    }, [props.scene]);
    // console.log(`HighLightLine.render() ${line}`);
    var viewport_height = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    var onScroll = throttler(function (event_target) {
        // console.log(`onScroll: position ${event_target.scrollTop}`);
        setLine(findNearestLine(event_target.scrollTop + viewport_height / 2));
    }, 250);
    var findNearestLine = function (scroll_position) {
        var nearest_line = props.scroll_position_map.reduce(function (prev, curr, index) {
            return curr < scroll_position ? index : prev;
        }, 1);
        // console.log(
        //   `findNearestLine(${scroll_position}) => ${nearest_line} (of ${props.scroll_position_map.length} entries)`
        // );
        return nearest_line;
    };
    return (React.createElement("div", { className: "scene", ref: div_ref, onScroll: onScroll },
        React.createElement("p", { className: "scene_direction" }, props.scene.direction),
        props.scene.content.map(function (content, index) { return (React.createElement(Speech_1["default"], { content: content, getPersonLabel: props.getPersonLabel, ident: "".concat(props.ident, ".").concat(index), key: index, scroll_position_map: props.scroll_position_map, selected_line: line })); }),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null)));
};
var ShowScene = function (props) {
    var scroll_position_map = [];
    console.log("ShowScene.render() ".concat(scroll_position_map.length));
    return (React.createElement("div", null,
        React.createElement(HighLightLine, { scroll_position_map: scroll_position_map, getPersonLabel: props.getPersonLabel, ident: props.ident, scene: props.scene })));
};
exports["default"] = ShowScene;
